import React from 'react';
import moment from 'moment';

const Columns = () => {
  return [
    {
      title: 'Time',
      dataIndex: 'created_at',
      align: 'left',
      render: (text) => moment(text * 1000).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      title: 'CRM ID',
      dataIndex: 'project',
      align: 'center',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      align: 'center',
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
      align: 'center',
    },
    {
      title: 'Daily Price',
      dataIndex: 'price',
      align: 'right',
      render: (text) => <span className='gx-text-primary'>{text.toLocaleString('us')}đ</span>
    },
    {
      title: 'Người tạo',
      dataIndex: 'created_by',
      align: 'center',
    },
  ];
};

export default Columns;
